import React from "react";
import { Button, Spin } from "antd";
import { ContainerCardsAreas, ContainerCardsSymbology } from "../../../components/container";
import { PieChartGeneral } from "../../../components/Graphics/PieChartGeneral";
import { ToggleSectionButton } from "../../../components/Buttons";
import { percentValue } from "../../../helpers/operationMath";
import { CardTable } from "../../../components/Card/CardTable";
import { CustomModalPortal } from "../../../components/Custom/CustomModalPortal";
import { ReloadArrow } from "../../../components/icons";
import useGraphInternal from "./hooks/useGraphInternal";
import ModalInternal from "./components/ModalInternal";
import FormSection from "./components/FormSection";
import FormSectionEdit from "./components/FormSectionEdit";
import FormSectionDelete from "./components/FormSectionDelete";

const sections = ["Tabla", "Gráfica"];

export const PageGraphInternal = () => {
    const {
        hasAction,
        modalInfo,
        isLoading,
        tasks,
        listOfYears,
        updateYear,
        year,
        selectedSection,
        handleSectionChange,
        openModalEditSection,
        openModalCreateSection,
        handleReaload,
        handleRealoadBySection,
        closeModal,
        onFinishForm,
        openModalDeleteSection,
    } = useGraphInternal()

    const titleModal = () => {
        switch (modalInfo.type) {
            case "create":
                return "Crear Sección";
            case "update":
                return "Editar Sección";
            case "delete":
                return "Eliminar Sección";
            default:
                return "";
        }
    }

    if (isLoading) return (
        <div className="flex justify-center items-center w-full min-h-[calc(100vh-64px)]">
            <Spin size="large" />
        </div>
    );

    return (
        <div className="lg:p-12 p-4  w-full h-[calc(100vh-64px)]">
            <CustomModalPortal isVisible={modalInfo.visible}>
                <ModalInternal
                    title={titleModal()}
                    onCancel={() => closeModal()}
                >
                    {modalInfo.type === "create" && (
                        <FormSection
                            onClose={onFinishForm} />
                    )}
                    {modalInfo.type === "update" && (
                        <FormSectionEdit
                            data={modalInfo.data}
                            onClose={onFinishForm} />
                    )}
                    {modalInfo.type === "delete" && (
                        <FormSectionDelete
                            data={modalInfo.data}
                            onClose={onFinishForm} />
                    )}
                </ModalInternal>
            </CustomModalPortal>
            <CardTable currentValue={year} listValues={listOfYears} updateValue={updateYear} title="Tabla - Gráfica de distribución de horas internas">
                <div className="w-full h-full  flex flex-col ">
                    <div className="w-full pb-6 flex md:justify-end ">
                        <div className="w-full md:w-[212px] p-1 ">
                            <ToggleSectionButton
                                sections={sections}
                                handleSectionChange={handleSectionChange}
                                selectedSection={selectedSection}
                            />
                        </div>
                    </div>
                    <div className="w-full p-1 flex justify-center md:justify-end items-center gap-2 ">
                        <div onClick={() => handleReaload()} className="w-[30px] h-[30px] cursor-pointer bg-primaryTwo rounded-md p-1">
                            <ReloadArrow color="#fff" />
                        </div>
                        {hasAction && (
                            <Button type="primary" onClick={() => openModalCreateSection()}>
                                Crear Seccion
                            </Button>
                        )}
                    </div>
                    <div className="w-full h-full">
                        <section className={`w-full mt-4 md:mt-8 flex flex-col xl:flex-row justify-center xl:justify-around items-center gap-6 md:gap-4 lg:gap-10 ${selectedSection ? "block" : "hidden"}`}>
                            <PieChartGeneral
                                className="sm:w-[300px]  sm:h-[300px] md:w-[400px]  md:h-[400px] "
                                pieChartProps={{
                                    data: tasks.graph,
                                    layers: ["arcs", "arcLabels", CenteredMetric],
                                    margin: { top: 0, right: 0, bottom: 0, left: 0 },
                                    innerRadius: 0.6,
                                    valueFormat: (value) => {
                                        const sumReduce = tasks.graph.reduce((total, item) => (total += item.value), 0);
                                        const percent = percentValue(sumReduce, value);
                                        return `${percent}%`;
                                    },
                                }}
                            />
                            <ContainerCardsSymbology
                                data={tasks.graph}
                                title="Secciones"
                                labelName="label"
                                labelBold={true}
                                childWith="w-[100px] md:w-[100px] lg:w-[150px] uppercase"
                                extraClass="max-w-[500px] xl:max-w-[800px]"
                            />
                        </section>
                        <section className={`w-full mt-5 md:mt-2 ${!selectedSection ? "block" : "hidden"}`}>
                            <ContainerCardsAreas
                                datas={tasks.sections}
                                callReload={handleRealoadBySection}
                                callEdit={openModalEditSection}
                                callDelete={openModalDeleteSection}
                                hasAction={hasAction}
                            />
                        </section>
                    </div>
                </div>
            </CardTable>
        </div>
    );
};

const CenteredMetric = ({ dataWithArc, centerX, centerY }) => {
    let total = 0;
    dataWithArc.forEach((datum) => {
        total += datum.value;
    });

    return (
        <text
            x={centerX}
            y={centerY}
            textAnchor="middle"
            dominantBaseline="central"
            style={{
                fontSize: "20px",
                fontWeight: 600,
            }}
        >
            {total.toFixed(2)} horas
        </text>
    );
};
